import React from 'react';
import { Phone, Mail, MessageSquare, Search, CalendarCheck, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

const SERVICES = [
  {
    testid: 'service-card-receptionist',
    Icon: Phone,
    title: 'AI Receptionist',
    description:
      'A 24/7 voice agent that answers calls, takes bookings and captures every enquiry, even when your team is busy or off the clock.',
  },
  {
    testid: 'service-card-whatsapp',
    Icon: MessageSquare,
    title: 'WhatsApp AI Chatbot',
    description:
      'Instantly reply to patient enquiries on WhatsApp. Qualify, book and follow up on the channel patients actually use.',
  },
  {
    testid: 'service-card-email',
    Icon: Mail,
    title: 'Email Automations',
    description:
      'Automated nurture sequences for new leads, no shows and post treatment follow ups. Every lead gets the right message at the right time.',
  },
  {
    testid: 'service-card-seo',
    Icon: Search,
    title: 'SEO & Local Search',
    description:
      'Get found by patients searching for your services nearby. On page SEO, Google Business optimisation and content built for medical clinics.',
  },
  {
    testid: 'service-card-booking',
    Icon: CalendarCheck,
    title: 'Booking Automation',
    description:
      'Replace manual diary juggling with smart booking flows, reminders and rescheduling, synced directly to your existing calendar.',
  },
  {
    testid: 'service-card-reactivation',
    Icon: RefreshCw,
    title: 'Patient Reactivation',
    description:
      "Bring back patients who haven't booked in a while with targeted re engagement campaigns across SMS, email and WhatsApp.",
  },
];

export const ServicesGrid = ({ onBookConsultation }) => {
  return (
    <section id="services" className="section section-alt" data-testid="services-section">
      <div className="container max-w-6xl">
        <div className="text-center mb-12">
          <h2
            className="text-4xl md:text-5xl font-bold mb-6"
            style={{ color: '#1a202c', letterSpacing: '-0.02em' }}
          >
            Everything handled for you
          </h2>
          <p
            className="text-xl md:text-2xl"
            style={{ color: '#4a5568', lineHeight: '1.6', maxWidth: '800px', margin: '0 auto' }}
          >
            A complete system that captures, converts and retains patients without adding workload to your team.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map(({ testid, Icon, title, description }) => (
            <div key={testid} className="service-card" data-testid={testid}>
              <div className="service-icon">
                <Icon className="w-6 h-6" />
              </div>
              <h3 className="service-title">{title}</h3>
              <p className="service-description">{description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <Button
            onClick={onBookConsultation}
            className="btn-primary btn-large"
            data-testid="services-cta-btn"
            style={{ fontSize: '1.125rem', padding: '18px 36px' }}
          >
            Book a Free Consultation
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
